import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/refinancia/daviplata-logo.webp'
import _imports_1 from '@/assets/img/refinancia/canales-efecty.svg'
import _imports_2 from '@/assets/img/refinancia/canales-472.svg'
import _imports_3 from '@/assets/img/refinancia/canales-punto-red.svg'
import _imports_4 from '@/assets/img/refinancia/canales-mercar.svg'
import _imports_5 from '@/assets/img/refinancia/canales-edeq.svg'
import _imports_6 from '@/assets/img/refinancia/canales-servi-pago.svg'
import _imports_7 from '@/assets/img/refinancia/canales-punto-de-pago.svg'
import _imports_8 from '@/assets/img/refinancia/bancolombia.svg'


const _withScopeId = n => (_pushScopeId("data-v-bed242e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-left" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-primary text-lg font-bold text-center" }, [
    /*#__PURE__*/_createTextVNode(" Ya no es necesario generar un cupón para realizar "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" el pago en el punto de pago físico de su preferencia. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "text-gris120 py-2 lg:py-4" }, " Cuando se acerque al punto de pago, indique los siguientes datos: ")
], -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "bg-white rounded-md p-4 shadow-md mt-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-alliance display-desktop w-32",
    src: _imports_0,
    alt: "daviplata"
  })
], -1))
const _hoisted_5 = { class: "bg-lightSurface-50 rounded-md p-2 text-xs md:text-sm mt-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-left text-primary" }, [
  /*#__PURE__*/_createTextVNode(" Opciones: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gris120 font-normal" }, "Otros Servicios")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-left" }, [
  /*#__PURE__*/_createTextVNode(" Convenio: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gris120 font-normal uppercase" }, " Fintech Referencia - Listo Pago A Plazos ")
], -1))
const _hoisted_8 = { class: "font-bold text-left text-primary" }
const _hoisted_9 = { class: "text-gris120 font-normal" }
const _hoisted_10 = { class: "bg-white rounded-md p-4 shadow-md mt-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo-alliance display-desktop",
      src: _imports_1,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo-alliance display-desktop",
      src: _imports_2,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo-alliance display-desktop",
      src: _imports_3,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo-alliance display-desktop",
      src: _imports_4,
      alt: ""
    })
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo-alliance display-desktop",
      src: _imports_5,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo-alliance display-desktop",
      src: _imports_6,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo-alliance display-desktop",
      src: _imports_7,
      alt: ""
    })
  ])
], -1))
const _hoisted_13 = { class: "bg-lightSurface-50 rounded-md p-2 text-xs md:text-sm" }
const _hoisted_14 = { class: "text-primary font-bold text-left" }
const _hoisted_15 = { class: "text-gris120 font-normal" }
const _hoisted_16 = { class: "font-bold text-left text-primary" }
const _hoisted_17 = { class: "text-gris120 font-normal" }
const _hoisted_18 = { class: "bg-white rounded-md p-4 shadow-md mt-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-alliance display-desktop w-32",
    src: _imports_8,
    alt: "daviplata"
  })
], -1))
const _hoisted_20 = { class: "bg-lightSurface-50 rounded-md p-2 text-xs md:text-sm mt-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-left text-primary" }, [
  /*#__PURE__*/_createTextVNode(" Convenio: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gris120 font-normal" }, "50444 PA Refinancia Fenalco")
], -1))
const _hoisted_22 = { class: "font-bold text-left text-primary" }
const _hoisted_23 = { class: "text-gris120 font-normal" }
const _hoisted_24 = {
  key: 1,
  class: "flex flex-col gap-6"
}
const _hoisted_25 = { class: "flex justify-center mb-2" }
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = { class: "bg-lightSurface-50 rounded-md p-2" }
const _hoisted_28 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-4 text-left justify-center text-xs md:text-sm" }
const _hoisted_29 = { class: "font-bold text-primary" }
const _hoisted_30 = { class: "text-gris120 font-normal" }
const _hoisted_31 = { class: "font-bold text-primary" }
const _hoisted_32 = { class: "text-gris120 font-normal" }
const _hoisted_33 = { class: "font-bold text-primary" }
const _hoisted_34 = { class: "text-gris120 font-normal" }
const _hoisted_35 = { class: "font-bold text-primary" }
const _hoisted_36 = { class: "text-gris120 font-normal" }
const _hoisted_37 = { class: "font-bold text-primary" }
const _hoisted_38 = { class: "text-gris120 font-normal" }
const _hoisted_39 = { class: "font-bold text-primary" }
const _hoisted_40 = { class: "text-gris120 font-normal" }
const _hoisted_41 = {
  key: 1,
  class: "font-bold text-left text-primary"
}
const _hoisted_42 = { class: "text-gris120 font-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createBlock(_component_new_modal, {
        key: 0,
        "custom-class": _ctx.setHeight,
        onCloseModal: _ctx.close
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          (_ctx.existCovenantAttr)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _hoisted_7,
                    _createElementVNode("p", _hoisted_8, [
                      _createTextVNode(" Referencia única de pago: "),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.paymentChannels.reference), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("p", _hoisted_14, [
                      _createTextVNode(" Número de convenio: "),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.paymentChannels.covenant), 1)
                    ]),
                    _createElementVNode("p", _hoisted_16, [
                      _createTextVNode(" Referencia única de pago: "),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.paymentChannels.reference), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("p", _hoisted_22, [
                      _createTextVNode(" Referencia única de pago: "),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.paymentChannels.reference), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.existCovenantAttr)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channels, (channel, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "bg-white rounded-md p-4 shadow-md",
                    key: key
                  }, [
                    _createElementVNode("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channel?.logos, (logo, key) => {
                        return (_openBlock(), _createElementBlock("img", {
                          class: _normalizeClass([channel?.branch_coupon ? 'w-20' : 'w-14']),
                          key: key,
                          src: logo,
                          alt: channel?.bank
                        }, null, 10, _hoisted_26))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("p", _hoisted_29, [
                            _createTextVNode(" Entidad: "),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(channel?.bank), 1)
                          ]),
                          _createElementVNode("p", _hoisted_31, [
                            _createTextVNode(" Tipo de cuenta: "),
                            _createElementVNode("span", _hoisted_32, _toDisplayString(channel?.account_type), 1)
                          ]),
                          _createElementVNode("p", _hoisted_33, [
                            _createTextVNode(" Número de cuenta: "),
                            _createElementVNode("span", _hoisted_34, _toDisplayString(channel?.account), 1)
                          ]),
                          _createElementVNode("p", _hoisted_35, [
                            _createTextVNode(" Número de convenio: "),
                            _createElementVNode("span", _hoisted_36, _toDisplayString(channel?.covenant_code), 1)
                          ]),
                          (_ctx.isNpl)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("p", _hoisted_37, [
                                  _createTextVNode(" Referencia 1: "),
                                  _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.paymentChannels.identification), 1)
                                ]),
                                _createElementVNode("p", _hoisted_39, [
                                  _createTextVNode(" Referencia 2: "),
                                  _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.paymentChannels.obligationId), 1)
                                ])
                              ], 64))
                            : (_openBlock(), _createElementBlock("p", _hoisted_41, [
                                _createTextVNode(" Referencia única de pago: "),
                                _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.paymentChannels.reference), 1)
                              ]))
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["custom-class", "onCloseModal"]))
    : _createCommentVNode("", true)
}